/**
 * Persist G703 grid draft state per pay app across navigation (sessionStorage).
 */

import type { G703DraftSlice } from './g703GridLogic'

const KEY_PREFIX = 'ci_g703_draft_'

function storageKey(payAppId: number): string {
  return `${KEY_PREFIX}${payAppId}`
}

export function loadG703Draft(payAppId: number): G703DraftSlice[] | null {
  try {
    const raw = sessionStorage.getItem(storageKey(payAppId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as G703DraftSlice[]
    return Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function saveG703Draft(payAppId: number, draft: G703DraftSlice[]): void {
  try {
    sessionStorage.setItem(storageKey(payAppId), JSON.stringify(draft))
  } catch { /* quota / private mode */ }
}

export function clearG703Draft(payAppId: number): void {
  try {
    sessionStorage.removeItem(storageKey(payAppId))
  } catch { /* ignore */ }
}
